import React from 'react';
import { bonuses } from '../data/modules';
import { OFFER_ANCHOR } from './constants';
export function BonusSection() {
  return <section className="border-y border-ink-line bg-ink-panel px-4 py-8" data-id="element-24" data-mp="1of2eo40xkga7">
      <div className="mx-auto max-w-4xl text-center" data-id="element-25" data-mp="22fwo8pzpsnag">
        <h2 className="text-xl font-extrabold sm:text-3xl" data-id="element-26" data-mp="22dissg14h92d">🎁 5 Premium Bonuses Included</h2>
        <p className="mx-auto mt-2 max-w-2xl text-sm leading-snug text-ink-text sm:text-base" data-id="element-27" data-mp="1ybxagf5tk2ks">
          You'll also receive five premium bonuses designed to help you save even more
          preparation time, improve therapy outcomes, and deliver an even more professional
          clinical experience.
        </p>

        <div className="mt-5 grid gap-3 text-left sm:grid-cols-2" data-id="element-28" data-mp="1eq2dqf2vbatd">
          {bonuses.map(bonus => <a key={bonus.label} href={OFFER_ANCHOR} className="rounded-xl border border-ink-line bg-ink-bg p-4 transition-colors hover:border-gold" data-id="element-29" data-mp="1eo7rmxfv1cnp">
              <p className="font-display text-[11px] font-bold uppercase tracking-widest text-gold" data-id="element-30" data-mp="mxtkdk2cqyl0">
                🎁 {bonus.label}
              </p>
              <h3 className="mt-0.5 text-[13px] font-bold leading-tight sm:text-base" data-id="element-31" data-mp="29q8oylbiwzh4">
                {bonus.title}
              </h3>
              <p className="mt-1 text-xs leading-snug text-ink-text sm:text-sm" data-id="element-32" data-mp="2jhmmwonttr85">
                {bonus.description}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}